module.exports = __webpack_public_path__ + "img/airhelp.e085ea4.png";